export default __webpack_public_path__ + "static/media/1945.5b9c6895.png";